<template>
  <app-layout title="Information">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        お知らせ一覧
      </h2>
    </template>
    <div class="mx-auto px-4 py-4 flex flex-col items-center">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="flex flex-row-reverse">
          <button
            class="m-5 px-8 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg"
            @click.prevent="onCreateClicked">
            新規作成
          </button>
        </div>

        <div class="py-2 align-middle inline-block min-w-max sm:px-6 lg:px-8">
          <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table class="min-w-max divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    カテゴリ
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    件名
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    公開設定
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    公開先
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    追加日
                  </th>
                  <th
                    scope="col"
                    class="relative px-6 py-3">
                    <span class="sr-only">
                      編集
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody
                v-for="(information, i) in informationList"
                :key="i"
                class="bg-white divide-y divide-gray-200">
                <tr>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="flex items-center">
                      <div class="text-sm text-gray-900">
                        {{ informationCategories[information.category_id] }}
                      </div>
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="text-sm text-gray-900">
                      {{ information.subject }}
                    </div>
                  </td>
                  <td
                    v-if="information.is_published"
                    class="px-6 py-4 whitespace-nowrap">
                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                      公開
                    </span>
                  </td>
                  <td
                    v-if="!information.is_published"
                    class="px-6 py-4 whitespace-nowrap">
                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
                      非公開
                    </span>
                  </td>
                  <td
                    class="px-6 py-4 whitespace-nowrap">
                    <span class="text-sm text-gray-900">
                      {{ getTarget(information) }}
                    </span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <span class="px-2 inline-flex text-sm leading-5 rounded-full text-gray-900">
                      {{ formatDate(information.created_at) }}
                    </span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <button
                      class="text-indigo-600 hover:text-indigo-900"
                      @click="edit(information)">
                      編集
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script setup>
import moment from 'moment'
import {
  computed,
} from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { usePage } from '@inertiajs/inertia-vue3'
import formatDate from '@/actions/format/date'
import AppLayout from '@/Layouts/AppLayout'

const props = defineProps({
  informationList: {
    type: Array,
    default: () => [],
  },
})

const informationCategories = computed(() => usePage().props.value.informationCategories)

const edit = (information) => {
  Inertia.get(route('information.show', {
    information,
  }))
}

const onCreateClicked = () => {
  Inertia.get(route('information.create'))
}

const getTarget = (information) => {
  const { target } = information
  switch (target) {
    case 0:
      return '全て'
    case 1:
      return '模試'
    case 2:
      return 'アプリ'
    default:
      return '全て'
  }
}
</script>
